export default "__VITE_ASSET__DoG9PA8G__"